//import { Notification } from "element-ui";
import { api } from "../../gateways/unilabApi";

export default {
  convertUsrRef(umPair) {
    return new Promise((resolve, reject) => {
      api
        .post("conversion/usr/ref", umPair)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.data.errorMessage
          //});
          reject(error);
        });
    });
  },
  convertUnidatoRefUsr(dto) {
    return new Promise((resolve, reject) => {
      api
        .post("conversion/unidato/ref/usr", dto)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          // title: "Attenzione",
          //  message: error.errorMessage
          //});
          reject(error);
        });
    });
  },
  validateUsrValue(dto) {
    return new Promise((resolve, reject) => {
      api
        .post("conversion/unidato/validate/usr", dto)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.errorMessage
          //});
          reject(error);
        });
    });
  },
  correlateValues(dto) {
    return new Promise((resolve, reject) => {
      api
        .post("conversion/unidato/correlate/usr", dto)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.errorMessage
          //});
          reject(error);
        });
    });
  },
  convertCorrelatedUnidata(unidata) {
    return new Promise((resolve, reject) => {
      console.clear();
      console.log(JSON.stringify(unidata));

      api
        .post("conversion/unidato/correlated/calculate", unidata)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.data.errorMessage
          //});
          reject(error);
        });
    });
  }
};
